<template>
  <div class="svenskaspel_integ_main_container hello">

<!--
    <span @click="clickButton()">{{ connected ? 'Connected' : 'Disconnected' }}</span>

    {{$atts}}
    {{subscriptions}}

    {{this.$socket.store.state.subscription}}
    {{this.$socket.store.state.drawObject}}
-->

<div v-if="getDrawObject">

  <div
  class="drawHeader"
  :style="$atts.product == 'europatipset' ? 'background:rgb(0 128 41)' : 'background:rgb(0 64 119)'
  ">
      <div>
          <img v-if="$atts.product == 'europatipset'" alt="Europatipset logo" src="https://kingofazure.com/wp-content/plugins/svenskaspel/src/europatipset-logo.png" style="max-width:200px;">
          <img v-else alt="Stryktipset logo" src="https://kingofazure.com/wp-content/plugins/svenskaspel/src/stryktipset-logo.png" style="max-width:200px;">
      </div>
      <div>
        {{getDrawObject.draw.drawComment}}<br>
        <span v-if="getDrawObject.result.length == 0">
        Spelstopp: {{this.shorterDate(getDrawObject.draw.regCloseTime)}}
        </span>
        <span>
          <img
          v-if="getDrawObject.forecast.drawnum"
          @click="soundNotify = !soundNotify; playMessage('')"
          style="width:20px;background:white;border-radius:5px;padding:5px;"
          :src="soundNotify ? 'data:image/svg+xml;base64,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' : 'data:image/svg+xml;base64, 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'"
          />
        </span>
      </div>
  </div>

    <!--Closetime: {{getCloseTime}}-->

    <div v-if="getDrawObject.draw.drawState == 'Open'" class="draw-container">
      <DrawOpen></DrawOpen>
    </div>

    <div v-if="getDrawObject.draw.drawState == 'Closed'" class="draw-container">
      <DrawClosed></DrawClosed>
    </div>

    <div v-if="getDrawObject.draw.drawState == 'Finalized'" class="draw-container">
      <DrawResult></DrawResult>
    </div>

</div>

  </div>
</template>

<script>
import DrawOpen from './DrawOpen.vue'
import DrawClosed from './DrawClosed.vue'
import DrawResult from './DrawResult.vue'
//import _ from 'lodash'

export default {
  components: {
    DrawOpen, DrawClosed, DrawResult
  },
  data: () => ({
    name: 'HelloWorld',
    audioLocked: true,
    soundNotify: false,
    styles: {}
  }),
  watch: {
    getForecastObjectEvents(newTitle, oldTitle) {

      console.log(newTitle);
      console.log(oldTitle)
      for (const [i, v] of newTitle.entries()) {
        if (oldTitle[i]) {
            if (oldTitle[i].home && v.home != oldTitle[i].home) {
              this.styles[v.eventNumber] = {}
              this.styles[v.eventNumber].home = {
                color:'green'
              }

              const vm = this;

              setTimeout(function(){
                vm.styles[v.eventNumber] = null
              }, 10000);
              if (this.soundNotify)
              this.playMessage("Goal in game number " + v.eventNumber + ', ' + v.match.participants[0].name + ' versus' + v.match.participants[1].name)
            }
            if (oldTitle[i].away && v.away != oldTitle[i].away) {
              this.styles[v.eventNumber] = {}
              this.styles[v.eventNumber].away = {
                color:'green'
              }

              const vm = this;

              setTimeout(function(){
                vm.styles[v.eventNumber] = null
              }, 10000);
              if (this.soundNotify)
              this.playMessage("Goal in game number " + v.eventNumber + ', ' + v.match.participants[0].name + ' versus' + v.match.participants[1].name)
            }

        }
      }
    }
  },
  computed: {
    connected() {
      return this.$socket.store.state.socket.connected;
    },
    subscriptions() {
      return this.$socket.store.state.subscription;
    },
    getDrawObject() {
      return this.$socket.store.state.drawObject[this.$atts.draw] ? this.$socket.store.state.drawObject[this.$atts.draw] : null;
    },
    getMultiForecast() {
      let MultiForecast = this.$socket.store.state.drawObject[this.$atts.draw].forecast.multiForecast || null;
      MultiForecast = MultiForecast ? this.groupBy(MultiForecast,'winDiv') : null;
      console.log(MultiForecast)
      return MultiForecast ? MultiForecast : null;
    },
    getForecastWinresult() {
      let getForecastWinresult = this.$socket.store.state.drawObject[this.$atts.draw].forecast.winresult || null;
      return getForecastWinresult ? getForecastWinresult : null;
    },
    getDrawObjectEvents() {
      return this.$socket.store.state.drawObject[this.$atts.draw].draw.drawEvents;
    },
    getForecastObjectEvents() {
      if (typeof(this.$socket.store.state.drawObject[this.$atts.draw]) === "undefined")
        return []

      let events = this.$socket.store.state.drawObject[this.$atts.draw].forecast.drawResults || [];
      let drawEvents = this.$socket.store.state.drawObject[this.$atts.draw].draw.drawEvents || [];
      return drawEvents.map(t1 => ({...t1, ...events.find(t2 => t2.eventNumber === t1.eventNumber)}))
    },
    getResultObjectEvents() {
      return this.$socket.store.state.drawObject[this.$atts.draw].result.events;
    },
    getCloseTime() {
      let regCloseTime = null
      if (this.getDrawObject) {
        console.log(this.getDrawObject)
        regCloseTime = this.$socket.store.state.drawObject[this.$atts.draw].draw.regCloseTime;
        regCloseTime = new Date(Date.parse(regCloseTime)).toISOString().replace(/T/, ' ').replace(/\..+/, '');
      }
      return regCloseTime;
    },
    getDrawTurnover() {
      // converts for example 219123123,56 -> 219 123 123
      return this.renderStyledAmount(this.$socket.store.state.drawObject[this.$atts.draw].draw.currentNetSale);
    },
    getResultTurnover() {
      // converts for example 219123123,56 -> 219 123 123
      return this.renderStyledAmount(this.$socket.store.state.drawObject[this.$atts.draw].result.currentNetSale);
    }
  },
  mounted() {
    console.log(this.$socket.store)
    this.connected = this.$socket.store.state.socket.connected
    this.$socket.subscribe(this.$atts.product, this.$atts.draw, payload => {
      console.log(payload)
    });

    this.checkSoundPermission();

  },
  methods: {
    playMessage(m) {
      console.log('playing message: ' + m)
      var msg = new SpeechSynthesisUtterance();
      var voices = window.speechSynthesis.getVoices();
      console.log(voices)
      msg.voice = voices[1];
      msg.voiceURI = 'native';
      msg.volume = 1;
      msg.rate = 1;
      msg.pitch = 2;
      msg.text = m;
      msg.lang = 'en-GB';
      //speechSynthesis.speak(msg);

      //Create the audio tag
      var soundFile = document.createElement("audio");
      soundFile.preload = "auto";

      //Load the sound file (using a source element for expandability)
      var src = document.createElement("source");
      src.src = 'https://kingofazure.com/wp-content/plugins/svenskaspel/build/mp3/goal.mp3';
      soundFile.appendChild(src);

      //Load the audio tag
      //It auto plays as a fallback
      soundFile.load();
      soundFile.volume = 0.000000;
      //Set the current time for the audio file to the beginning
      soundFile.currentTime = 0.01;

      if (this.soundNotify)
        soundFile.volume = 0.5;
      else
        soundFile.volume = 0.1;

        soundFile.play()
    },
    shorterDate(date) {
        return new Date(Date.parse(date)).toISOString().replace(/T/, ' ').replace(/\..+/, '');
    },
    renderStyledAmount(amount) {
      return parseFloat(amount).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
    },
    clickButton() {
      // this.$socket.client is `socket.io-client` instance
      console.log(this.getDrawObject)
      console.log(this.$socket)
    },
    checkSoundPermission() {
      const isAudioLocked = () => {
        return new Promise(resolve => {
          const checkHTML5Audio = async () => {
            const audio = new Audio();
            try {
              audio.play();
              resolve(false);
            } catch (err) {
              resolve(true);
            }
          };
          try {
            const context = new (window.AudioContext || window.webkitAudioContext)();
            resolve(context.state === 'suspended');
          } catch (e) {
            checkHTML5Audio();
          }
        });
      };
      const userGestureEvents = [
        'click',
        'contextmenu',
        'auxclick',
        'dblclick',
        'mousedown',
        'mouseup',
        'pointerup',
        'touchend',
        'keydown',
        'keyup',
      ];
      const unlockAudio = () => {
        this.audioLocked = false;
        console.log('Sound is unlocked');
        userGestureEvents.forEach(eventName => {
          document.removeEventListener(eventName, unlockAudio);
        });
      };
      if (isAudioLocked()) {
        this.audioLocked = true;
        console.log('Sound is locked');
        userGestureEvents.forEach(eventName => {
          document.addEventListener(eventName, unlockAudio);
        });
      }
    }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.turnover-container {
  font-weight:bold;
  text-align:center;
  padding:10px;
}
.winner-container {
  border:1px solid #ddd;
  padding:10px;
}
.drawHeader {
  display: flex;
  flex-wrap: nowrap;
}
.drawHeader > div:first-child {
  padding:3px;
  width:50%
}
.drawHeader > div:last-child {
  text-align:right;
  color:white;
  padding:4px;
  width:100%;
  font-size:80%
}
.draw-container {
  margin-bottom:1rem;
  background:white;
  border:1px solid #ddd;
}

.svenskaspel_integ_main_container {
  background: #f9f9f9;
  padding:4px;
  font-family: Mukta,Helvetica,Arial,sans-serif;
  font-size:14px;
  margin-bottom:1rem;
  max-width:500px;
}
.draw-events-flex-parent-container {
  border-bottom:1px solid #afafb3;
}
.draw-events-flex-container {
  display: flex;
  width:100%
}
.draw-events-flex-container > div {
  padding: 4px 4px;

}
.draw-events-flex-container > div:first-child {
  white-space:nowrap;
  max-width: 150px;
}
.draw-events-flex-container > div:nth-child(2) {
  margin-left: auto;
  text-align:center;
}
.draw-events-flex-container > div:last-child {
  text-align:center;
  min-width: 20px;
}
.event-game-title-prefix {
  font-weight:bold;
}
.event-game-title {
  margin-left:7px;
  font-size:14px;
}
.game-result-score {
  width:50px;
  text-align:center;
  font-size:80%;
  padding:2px 0px;
  background:#f1f1f1;
  margin-left:auto;
  margin-right:auto;
}
.game-result-cancelled {
  width:50px;
  text-align:center;
  font-size:80%;
  padding:2px 0px;
  color:red;
  font-weight:bold;
  margin-left:auto;
  margin-right:auto
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
